module.exports = __webpack_public_path__ + "static/media/Ketly-Logo_Final-Output_Normal.8f22cdaa.jpg";